import type { BootFallbackGridSpec } from "@slot/game-shell";

// 5 reels (columns) × 5 rows of the plain symbols, mixed per reel so no symbol stacks a column: the board before the
// first round and after a recovery. Rows separated by '|', columns by ',' (the platform's `DelimitedGridCodec`, which
// throws at the boot paint if this is not 5×5).
export const BOOT_FALLBACK_GRID: BootFallbackGridSpec = {
  encodedGridSnapshot:
    "H1,L2,H3,L4,H2|" +
    "L1,H2,L3,H4,L5|" +
    "H4,L5,H1,L2,H3|" +
    "L3,H1,L4,H2,L1|" +
    "H2,L4,H3,L5,H4",
  reelSetIdentifier: "default",
};
